const Support = () => import(/* webpackChunkName: "support" */ './Support.vue')

const index = {
  path: 'support',
  name: 'Support',
  component: Support,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
